import { objectSpread2 as _objectSpread2, defineProperty as _defineProperty, extends as _extends, taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import styled from 'styled-components';
import getInkColour from '../../utils/getInkColour.js';

var _templateObject;
var variantComponentMapping = {
  bodyMedium: 'p',
  bodyRegular: 'p',
  bodySmall: 'p',
  headingLarge: 'h1',
  headingMedium: 'h3',
  headingRegular: 'h2',
  headingSmall: 'h4',
  linkMedium: 'a',
  linkRegular: 'a',
  linkSmall: 'a'
};
var variants = Object.keys(variantComponentMapping);
function createTypographyStyles(variant) {
  return styled(variantComponentMapping[variant])(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n    font-family: ", ";\n    ", "\n    ", ";\n  "])), function (_ref) {
    var $colour = _ref.$colour,
      theme = _ref.theme;
    return $colour && "color: ".concat(getInkColour(theme, $colour), ";");
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.font.family;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.typography[variant];
  }, function (_ref4) {
    var _theme$typography$var;
    var theme = _ref4.theme;
    return ((_theme$typography$var = theme.typography[variant]) === null || _theme$typography$var === void 0 ? void 0 : _theme$typography$var.textDecoration) && "text-decoration: ".concat(theme.typography[variant].textDecoration);
  });
}
var styles = variants.reduce(function (allStyles, variant) {
  return _objectSpread2(_objectSpread2({}, allStyles), {}, _defineProperty({}, variant, createTypographyStyles(variant)));
}, {});
function getTypographyStyles(variant, as) {
  if (!styles[variant]) {
    styles[variant] = createTypographyStyles(variant);
  }
  var Style = styles[variant];
  return as ? function (props) {
    return React__default.createElement(Style, _extends({}, props, {
      as: as
    }));
  } : Style;
}

export { getTypographyStyles, variants };
//# sourceMappingURL=Typography.styles.js.map
